"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferPurposeSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.TransferPurposeSubCategory = (0, type_utils_1.makeEnum)({
    /** Fallback sub purpose */
    Transfer: 'TRANSFER',
});
//# sourceMappingURL=transfer.js.map